<template>
  <div>
    <div class="modal-box box">
      <header class="modal-card-head">
        <span class="modal-card-title">{{ member.name }}</span>
      </header>
      <section class="modal-card-body">
        <p>Reason: {{ member.reason }}</p>
        <p>Duration: {{ member.duration }}</p>
      </section>
      <footer class="modal-card-foot">
        <button
          class="button is-danger"
          @click.prevent="unban"
        >
          Unban Player
        </button>
        <button
          class="button"
          @click.prevent="close"
        >
          Cancel
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['member'],
    methods: {
      unban () {
        this.$emit('unbanMember', this.member.ahlid)
      },
      close () {
        this.$emit('close')
      }
    }
  }
</script>
